import { all } from 'redux-saga/effects'

import synchronizationGroupSaga from './synchronization/groupsSaga'
import synchronizationFavouritesSaga from './synchronization/favouritesSaga'
import synchronizationHistorySaga from './synchronization/historySaga'
import synchronizationEntityStackTabsSaga from './synchronization/entityStackTabsSaga'
import searchResultsSaga from './synchronization/searchSaga'
import synchronizationDialogSaga from './synchronization/dialogSaga'
import synchronizationModuleTabsDialogSaga from './synchronization/moduleTabsSaga'
import synchranizationWorkspaceTabsSaga from './synchronization/workspaceTabsSaga'

export default function* socketSaga() {
    yield all([
        synchronizationGroupSaga(),
        synchronizationFavouritesSaga(),
        synchronizationHistorySaga(),
        synchronizationEntityStackTabsSaga(),
        searchResultsSaga(),
        synchronizationDialogSaga(),
        synchronizationModuleTabsDialogSaga(),
        synchranizationWorkspaceTabsSaga(),
    ])
}
